import { del, downloadFile, downloadFileGet, get, post } from 'api/apiRequest';

export interface SettlementAgreementResponse {
  id: number;
  name: string;
  displayName: string;
  fileName: string;
  createdBy: string;
  createdDate: string;
}

export interface SettlementAgreementPost {
  name: string;
  displayName: string;
  fileName: string;
}

export type SettlementAgreementId = SettlementAgreementResponse['id'];

export const settlementAgreementTemplates = {
  get: () => get<SettlementAgreementResponse[]>('v1/SettlementAgreementTemplates'),
  post: (params: SettlementAgreementPost) =>
    post('v1/SettlementAgreementTemplates', params),
  delete: (id: SettlementAgreementId) =>
    del(`v1/SettlementAgreementTemplates/${id}`),
  download: (id: SettlementAgreementId, fileName: string) =>
    downloadFile(`v1/SettlementAgreementTemplates/${id}/download`, fileName),
  downloadHelp: () =>
    downloadFile(
      'v1/SettlementAgreementTemplates/help',
      'Settlement-Agreement-Help.docx',
    ),
  downloadSample: () =>
    downloadFile(
      'v1/SettlementAgreementTemplates/sample',
      'Agreement-Template.docx',
    ),

  getPreviewBlob: (id: SettlementAgreementId) =>
    downloadFileGet(`v1/SettlementAgreementTemplates/${id}/preview`),
};
